'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const index = require('./index-8d6fcb04.js');

const rgVideoCss = ":host{display:block;position:relative;padding-bottom:56.25%;height:0}::slotted(*){position:absolute;top:0;left:0;width:100%;background-color:black;height:100% !important;-o-object-fit:contain;object-fit:contain}";

const RgVideo = class {
    constructor(hostRef) {
        index.registerInstance(this, hostRef);
        // 1. Own properties
        // ---------------------------------------
        // 2. Reference to host HTML element
        // ---------------------------------------
        // 3. State() variables
        // ---------------------------------------
        // 4. Public Property API
        // ---------------------------------------
        /** adjust the child's height according to the set ratio. Write any ratio using a colon between two numbers, ie. '16:9'. **/
        this.ratio = "16:9";
    }
    // 5. Events section
    // ---------------------------------------
    // 6. Component lifecycle events
    // ---------------------------------------
    componentWillLoad() {
        // check if ratio is set
        if (this.ratio) {
            // ratio should be written at "number:number"
            let ratioArr = this.ratio.split(":");
            if (ratioArr.length == 2) {
                let width = parseFloat(ratioArr[0]);
                let height = parseFloat(ratioArr[1]);
                this.ratioPercentage = (height / width) * 100;
            }
        }
    }
    // 7. Listeners
    // ---------------------------------------
    // 8. Public methods API
    // ---------------------------------------
    // 9. Local methods
    // ---------------------------------------
    // 10. render() function
    // ---------------------------------------
    render() {
        let style = this.ratioPercentage
            ? {
                paddingBottom: this.ratioPercentage + "%",
            }
            : null;
        return (index.h(index.Host, { style: style }, index.h("slot", null)));
    }
};
RgVideo.style = rgVideoCss;

exports.rg_video = RgVideo;
